<template>
  <!-- 内容管理-投保流程 -->
  <div>
    <Modal v-model="visible" :title="title" width="600px" :footer-hide="true" :mask-closable="false" class="my-modal">
      <Form ref="form" :model="formData" class="page-form" :label-width="80" :disabled="!isEdit">
        <FormItem label="名称" class="full" prop="stepName" :rules="$units.formRule.required('请输入名称')">
          <Select v-model="formData.stepType" placeholder="请选择名称" clearable class="input" @on-change="nameChange()">
            <Option value="999"> 自定义 </Option>
            <Option v-for="text in typeList" :key="text" :value="text"> {{ text }} </Option>
          </Select>
          <Input v-if="formData.stepType == 999" v-model.trim="formData.stepName" class="input" placeholder="请输入名称" />
        </FormItem>
        <FormItem label="介绍" prop="describe" class="full" :rules="$units.formRule.required('请输入介绍')">
          <Input type="textarea" v-model.trim="formData.describe" placeholder="请输入" :rows="6" />
        </FormItem>
        <FormItem class="upload-item full" label="描述图片" prop="imgs">
          <uploadNew v-model="formData.imgs" fileType="img" :muti="true" tip="支持JPG、JPEG或PNG格式" :disabled="!isEdit"></uploadNew>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer" v-if="isEdit">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
export default {
  components: {
    uploadNew
  },
  props: {
    productForm:null,//产品信息
  },
  data() {
    return {
      visible: false,
      loading: false,
      isEdit: true,
      title:'',
      typeList: ['投保区域', '投保流程', '双录规则'],
      formData: {
        imgs: '',
        stepType: '',
        stepName: '',
        describe: ''
      },
      tableData: []
    };
  },
  mounted() {},
  methods: {
    open(data, isEdit = true) {
      this.isEdit = isEdit;
      data = JSON.parse(JSON.stringify(data));
      if(this.typeList.includes(data.stepName)) {
        data.stepType = data.stepName
      }else{
        data.stepType = '999'
      }
      if(data.imgs){
        data.imgs = JSON.parse(data.imgs);
      }else{
        data.imgs = [];
      }
      if(!isEdit){
        this.title = '详情';
      }else if(data.id){
        this.title = '编辑';
      }else{
        this.title = '新增';
      }
      data.imgs = data.imgs.map(item=>({path:item.path||item}));
      this.formData = data;
      this.visible = true;
      // 清除验证信息
      this.$nextTick(() => {
        this.$refs.form &&
          this.$refs.form.fields.forEach(item => {
            item.validateState = '';
            item.validateMessage = '';
          });
      });
    },
    nameChange() {
      if (this.formData.stepType == 999) {
        this.$set(this.formData, 'stepName', '');
      } else {
        this.$set(this.formData, 'stepName', this.formData.stepType);
      }
      this.$refs.form.validateField('stepName');
    },
    // 提交
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.formData))
          formData.imgs = formData.imgs.map(item=>item.path)
          const data = {
            type: 1,
            productId: this.productForm.id,
            productCode: this.productForm.productCode,
            productInsureProfile: {
              productId: this.productForm.id,
              productCode: this.productForm.productCode,
              id: formData.id,
              stepName: formData.stepName,
              describe: formData.describe,
              stepSeq: formData.stepSeq,
              type: 1,
              imgs: formData.imgs
            }
          }
          this.$http({
            url: '/buz/productInsureProfile/offline/update',
            type: 'POST',
            data
          }).then(res => {
            this.$emit('reload');
            this.productForm.insureProfileType = 1;
            this.visible = false;
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.input {
  &:nth-child(1) {
    width: 140px;
  }
  &:nth-child(2) {
    width: 260px;
    margin-left: 15px;
  }
}
</style>